import * as React from 'react'
import { useTranslation } from 'react-i18next'
import Input, { InputProps } from 'components/Input'

export const PhoneTypeSelect: React.FC<InputProps> = props => {
  const { t } = useTranslation()
  const options = [
    { label: t('Home'), value: 'home' },
    { label: t('Office'), value: 'office' },
  ]

  return <Input.Select {...props} placeholder="--" isClearable options={options} />
}
export default PhoneTypeSelect
